import React, { useEffect, useState } from "react"
import styles from "./RadioGroup.module.scss"

type TRadioGroup = {
    options: any
    onSelect: any
    value?: any
    disabled?: any
    labelsStyle?: React.CSSProperties
    name?: string
    optionStyle?: React.CSSProperties
}
function RadioGroup({ name, options, onSelect, value, disabled, labelsStyle, optionStyle }: TRadioGroup) {
    const [selectedOption, setSelectedOption] = useState("")

    useEffect(() => {
        setSelectedOption(value)
    }, [value])
    const handleOptionChange = (event: any) => {
        setSelectedOption(JSON.parse(event.target.value))
        onSelect(JSON.parse(event.target.value))
    }
    return (
        <div style={{ ...labelsStyle, cursor: disabled ? "not-allowed" : "pointer" }}>
            {options.map((option: any, index: any) => {
                return (
                    <label className={styles.radio_container} key={option?.id} style={{ ...optionStyle }}>
                        <input
                            name={name}
                            type="radio"
                            value={JSON.stringify(option)}
                            checked={JSON.stringify(selectedOption) == JSON.stringify(option)}
                            onChange={handleOptionChange}
                            disabled={disabled || option?.disabled}
                        />
                        <span>{option?.title}</span>
                    </label>
                )
            })}
        </div>
    )
}

export default RadioGroup
